import { useTabQueryParam } from '@/hooks/use-tab-query-param'
import { cn } from '@/lib/utils'
import { MemberCreditNotesTab } from './member-credit-notes-tab'
import { MemberInvoicesTab } from './member-invoices-tab'
import { MemberPaymentsTab } from './member-payments-tab'

type BillingSubTab = 'invoices' | 'credit-notes' | 'payments'
const SUB_TABS: { id: BillingSubTab; label: string }[] = [
  { id: 'invoices', label: 'Invoices' },
  { id: 'credit-notes', label: 'Credit Notes' },
  { id: 'payments', label: 'Payments' },
]
const VALID_SUB_TABS: BillingSubTab[] = ['invoices', 'credit-notes', 'payments']

export function MemberBillingTab({
  memberId,
  memberName,
}: {
  memberId: string
  memberName: string
}) {
  // A separate `billingTab` param, distinct from the parent profile view's `tab` param, so a
  // link can deep-link to e.g. this member's credit notes without disturbing the outer tab.
  const [subTab, setSubTab] = useTabQueryParam(VALID_SUB_TABS, 'invoices', 'billingTab')

  return (
    <div className="space-y-4">
      <div className="flex gap-1 border-b border-border-2">
        {SUB_TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setSubTab(t.id)}
            className={cn(
              'px-4 py-2.5 font-sans text-sm font-medium transition-colors',
              subTab === t.id
                ? 'border-b-2 border-primary text-ink'
                : 'text-muted-foreground hover:text-ink',
            )}
          >
            {t.label}
          </button>
        ))}
      </div>

      {subTab === 'invoices' && <MemberInvoicesTab memberId={memberId} />}
      {subTab === 'credit-notes' && <MemberCreditNotesTab memberId={memberId} />}
      {subTab === 'payments' && <MemberPaymentsTab memberId={memberId} memberName={memberName} />}
    </div>
  )
}
